// Where a SAFT-AI SSO principal lands, given their role and the company they were viewing.
//
// SAFT-AI deep-links to `/sso?token=<JWT>&nif=<NIF>`. The NIF is the agreed company join key
// (the same one partner-api uses at `GET /clients/{nif}`); it rides as a URL param rather than
// a JWT claim because the token contract carries no company — see the federation RFC. Unsigned
// is fine: it is only a VIEW HINT. RLS decides what is actually readable, so a tampered NIF
// shows either data the caller could already see, or nothing.
//
// Pure so the four cases are unit-testable without a session.

/**
 * @param role  `app_role` from the SSO exchange — 'client' means a portal user, anything else is firm staff.
 * @param clientId  our `clients.id` resolved from the NIF, or null when absent/unresolvable.
 */
export function ssoDestination(role: string | undefined, clientId: string | null): string {
  if (role === 'client') {
    // Portal: Início, not Documentos (Diogo, 2026-09-16). The landing page is the one that
    // frames the month — what is missing on the AT, where the spend went, what still needs
    // action — and every figure on it is a door into the list. Landing straight in the table
    // dropped a client into 2 000 rows with no statement of what mattered.
    // The company is addressable via ?empresa= (validated against the caller's own companies
    // in PortalLayout, which falls back to the first one).
    return clientId ? `/portal/inicio?empresa=${clientId}` : '/portal/inicio'
  }
  // Staff: the global documents page filtered to one company — keeps bulk actions, export and
  // the full chip set, unlike the per-client page.
  return clientId ? `/operacoes/documentos?cliente=${clientId}` : '/operacoes'
}
